module.exports = __webpack_public_path__ + "images/4-en.jpg?v=72f730244b7581aea96bf3ee7e49b356";